import { Box, Text } from "@chakra-ui/react";

export const KYDEventIcon = () => (
  <Box
    w="6"
    h="6"
    borderRadius="sm"
    display="flex"
    alignItems="center"
    justifyContent="center"
    color="#666666"
  >
    <svg viewBox="0 0 31 17" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M31 17V12.9316H20.5833L27.9346 5.82729L24.9946 2.91246L17.643 10.0168V0H13.357L13.3816 9.94556L6.08168 2.91246L3.06544 5.82729L10.4413 12.9316H0V17H31Z"
        fill="currentColor"
      />
    </svg>
  </Box>
);

export const SocialIcon = () => (
  <Box
    w="6"
    h="6"
    borderRadius="sm"
    display="flex"
    alignItems="center"
    justifyContent="center"
    color="#666666"
  >
    <svg
      width="32"
      height="23"
      viewBox="0 0 32 23"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M30.8961 13.3592C30.7865 13.4414 30.6617 13.5013 30.5289 13.5353C30.3961 13.5693 30.258 13.5768 30.1223 13.5575C29.9866 13.5381 29.856 13.4922 29.7381 13.4223C29.6201 13.3525 29.5171 13.2601 29.4349 13.1504C28.8057 12.3048 27.9869 11.6187 27.0441 11.1473C26.1014 10.676 25.0612 10.4325 24.0072 10.4366C23.802 10.4366 23.6013 10.3761 23.4302 10.2626C23.2592 10.1491 23.1254 9.98773 23.0456 9.79862C22.9915 9.6702 22.9635 9.53223 22.9635 9.39285C22.9635 9.25347 22.9915 9.1155 23.0456 8.98708C23.1254 8.79797 23.2592 8.63659 23.4302 8.52311C23.6013 8.40963 23.802 8.34909 24.0072 8.34908C24.5929 8.34902 25.1668 8.18473 25.6637 7.87486C26.1607 7.565 26.5608 7.12197 26.8186 6.59611C27.0764 6.07025 27.1815 5.48263 27.1221 4.9C27.0627 4.31737 26.8411 3.76309 26.4824 3.3001C26.1237 2.83712 25.6424 2.484 25.0931 2.28085C24.5439 2.0777 23.9486 2.03266 23.375 2.15086C22.8014 2.26905 22.2724 2.54573 21.8482 2.94948C21.424 3.35323 21.1215 3.86786 20.9751 4.43492C20.9408 4.56771 20.8807 4.69244 20.7982 4.80201C20.7158 4.91157 20.6125 5.00382 20.4944 5.07349C20.3763 5.14315 20.2456 5.18886 20.1098 5.20802C19.974 5.22718 19.8357 5.2194 19.703 5.18513C19.5702 5.15086 19.4454 5.09078 19.3359 5.0083C19.2263 4.92583 19.1341 4.82258 19.0644 4.70446C18.9947 4.58633 18.949 4.45564 18.9299 4.31985C18.9107 4.18405 18.9185 4.04582 18.9527 3.91303C19.156 3.12669 19.5399 2.39864 20.074 1.7868C20.6081 1.17495 21.2776 0.69621 22.0293 0.388659C22.781 0.0811075 23.5941 -0.0467627 24.4039 0.0152226C25.2137 0.0772079 25.9979 0.327338 26.694 0.74571C27.3901 1.16408 27.979 1.73915 28.4138 2.42515C28.8485 3.11116 29.1172 3.88916 29.1983 4.69727C29.2795 5.50537 29.171 6.32127 28.8813 7.08004C28.5917 7.83881 28.129 8.51951 27.53 9.06798C28.9492 9.68249 30.1831 10.6577 31.1088 11.8966C31.191 12.0065 31.2508 12.1316 31.2846 12.2647C31.3184 12.3977 31.3257 12.5362 31.3059 12.672C31.2862 12.8079 31.2398 12.9385 31.1695 13.0564C31.0992 13.1743 31.0063 13.2772 30.8961 13.3592ZM23.8663 21.3963C23.9418 21.5151 23.9925 21.6479 24.0154 21.7868C24.0382 21.9257 24.0328 22.0678 23.9993 22.2046C23.9658 22.3413 23.905 22.4698 23.8205 22.5824C23.736 22.6951 23.6297 22.7894 23.5078 22.8599C23.3859 22.9303 23.2511 22.9754 23.1113 22.9924C22.9716 23.0094 22.8298 22.9979 22.6946 22.9587C22.5594 22.9194 22.4336 22.8533 22.3246 22.7642C22.2156 22.675 22.1258 22.5648 22.0606 22.44C21.4031 21.3267 20.4666 20.404 19.3437 19.763C18.2207 19.122 16.95 18.7849 15.657 18.7849C14.364 18.7849 13.0933 19.122 11.9704 19.763C10.8474 20.404 9.91098 21.3267 9.25346 22.44C9.18821 22.5648 9.0984 22.675 8.98944 22.7642C8.88047 22.8533 8.75461 22.9194 8.61941 22.9587C8.48421 22.9979 8.34247 23.0094 8.20273 22.9924C8.06298 22.9754 7.92811 22.9303 7.80624 22.8599C7.68436 22.7894 7.57799 22.6951 7.49354 22.5824C7.40908 22.4698 7.34828 22.3413 7.31478 22.2046C7.28129 22.0678 7.27581 21.9257 7.29865 21.7868C7.3215 21.6479 7.37221 21.5151 7.44773 21.3963C8.45967 19.6576 10.0026 18.2893 11.8499 17.4925C10.8104 16.6967 10.0465 15.5952 9.66549 14.3427C9.28448 13.0903 9.30552 11.7499 9.72566 10.5101C10.1458 9.27023 10.9439 8.1932 12.0078 7.43039C13.0717 6.66758 14.3479 6.25734 15.657 6.25734C16.9661 6.25734 18.2423 6.66758 19.3062 7.43039C20.3701 8.1932 21.1682 9.27023 21.5884 10.5101C22.0085 11.7499 22.0296 13.0903 21.6486 14.3427C21.2675 15.5952 20.5036 16.6967 19.4642 17.4925C21.3114 18.2893 22.8544 19.6576 23.8663 21.3963ZM15.657 16.6993C16.4828 16.6993 17.29 16.4544 17.9766 15.9956C18.6632 15.5369 19.1983 14.8848 19.5143 14.1219C19.8303 13.359 19.913 12.5195 19.7519 11.7097C19.5908 10.8998 19.1932 10.1558 18.6093 9.57193C18.0254 8.98804 17.2814 8.5904 16.4715 8.4293C15.6617 8.2682 14.8222 8.35088 14.0593 8.66689C13.2964 8.98289 12.6443 9.51802 12.1856 10.2046C11.7268 10.8912 11.4819 11.6984 11.4819 12.5242C11.4819 13.6315 11.9218 14.6934 12.7048 15.4764C13.4878 16.2594 14.5497 16.6993 15.657 16.6993ZM8.3506 9.39285C8.3506 9.11602 8.24063 8.85054 8.04488 8.65479C7.84914 8.45904 7.58365 8.34908 7.30682 8.34908C6.72117 8.34902 6.14727 8.18473 5.65031 7.87486C5.15335 7.565 4.75325 7.12197 4.49545 6.59611C4.23766 6.07025 4.1325 5.48263 4.19193 4.9C4.25136 4.31737 4.47299 3.76309 4.83165 3.3001C5.19031 2.83712 5.67161 2.484 6.2209 2.28085C6.77019 2.0777 7.36544 2.03266 7.93904 2.15086C8.51265 2.26905 9.0416 2.54573 9.46584 2.94948C9.89007 3.35323 10.1926 3.86786 10.339 4.43492C10.4082 4.70309 10.5811 4.93279 10.8197 5.07349C11.0582 5.21418 11.3429 5.25434 11.6111 5.18513C11.8793 5.11593 12.109 4.94302 12.2497 4.70446C12.3903 4.46589 12.4305 4.18121 12.3613 3.91303C12.1581 3.12669 11.7741 2.39864 11.24 1.7868C10.7059 1.17495 10.0364 0.69621 9.28471 0.388659C8.53303 0.0811075 7.71993 -0.0467627 6.91013 0.0152226C6.10033 0.0772079 5.31617 0.327338 4.62005 0.74571C3.92393 1.16408 3.33506 1.73915 2.90029 2.42515C2.46553 3.11116 2.19687 3.88916 2.1157 4.69727C2.03452 5.50537 2.14307 6.32127 2.43271 7.08004C2.72235 7.83881 3.18508 8.51951 3.78408 9.06798C2.36622 9.68307 1.13382 10.6582 0.209151 11.8966C0.0428821 12.1181 -0.0286018 12.3965 0.010425 12.6707C0.0494518 12.9448 0.195792 13.1923 0.417253 13.3585C0.638715 13.5248 0.917155 13.5963 1.19132 13.5573C1.46549 13.5182 1.71292 13.3719 1.87919 13.1504C2.50831 12.3048 3.32719 11.6187 4.2699 11.1473C5.21262 10.676 6.25284 10.4325 7.30682 10.4366C7.58365 10.4366 7.84914 10.3267 8.04488 10.1309C8.24063 9.93517 8.3506 9.66968 8.3506 9.39285Z"
        fill="#666666"
      />
    </svg>
  </Box>
);

export const UploadIcon = () => (
  <Box
    w="6"
    h="6"
    borderRadius="sm"
    display="flex"
    alignItems="center"
    justifyContent="center"
    color="#666666"
  >
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="32"
      height="32"
      fill="currentColor"
      viewBox="0 0 16 16"
    >
      <path
        fillRule="evenodd"
        d="M14 4.5V14a2 2 0 0 1-2 2h-1v-1h1a1 1 0 0 0 1-1V4.5h-2A1.5 1.5 0 0 1 9.5 3V1H4a1 1 0 0 0-1 1v9H2V2a2 2 0 0 1 2-2h5.5zM3.517 14.841a1.13 1.13 0 0 0 .401.823q.195.162.478.252.284.091.665.091.507 0 .859-.158.354-.158.539-.44.187-.284.187-.656 0-.336-.134-.56a1 1 0 0 0-.375-.357 2 2 0 0 0-.566-.21l-.621-.144a1 1 0 0 1-.404-.176.37.37 0 0 1-.144-.299q0-.234.185-.384.188-.152.512-.152.214 0 .37.068a.6.6 0 0 1 .246.181.56.56 0 0 1 .12.258h.75a1.1 1.1 0 0 0-.2-.566 1.2 1.2 0 0 0-.5-.41 1.8 1.8 0 0 0-.78-.152q-.439 0-.776.15-.337.149-.527.421-.19.273-.19.639 0 .302.122.524.124.223.352.367.228.143.539.213l.618.144q.31.073.463.193a.39.39 0 0 1 .152.326.5.5 0 0 1-.085.29.56.56 0 0 1-.255.193q-.167.07-.413.07-.175 0-.32-.04a.8.8 0 0 1-.248-.115.58.58 0 0 1-.255-.384zM.806 13.693q0-.373.102-.633a.87.87 0 0 1 .302-.399.8.8 0 0 1 .475-.137q.225 0 .398.097a.7.7 0 0 1 .272.26.85.85 0 0 1 .12.381h.765v-.072a1.33 1.33 0 0 0-.466-.964 1.4 1.4 0 0 0-.489-.272 1.8 1.8 0 0 0-.606-.097q-.534 0-.911.223-.375.222-.572.632-.195.41-.196.979v.498q0 .568.193.976.197.407.572.626.375.217.914.217.439 0 .785-.164t.55-.454a1.27 1.27 0 0 0 .226-.674v-.076h-.764a.8.8 0 0 1-.118.363.7.7 0 0 1-.272.25.9.9 0 0 1-.401.087.85.85 0 0 1-.478-.132.83.83 0 0 1-.299-.392 1.7 1.7 0 0 1-.102-.627zm8.239 2.238h-.953l-1.338-3.999h.917l.896 3.138h.038l.888-3.138h.879z"
      />
    </svg>
  </Box>
);

export const LookalikeIcon = ({
  backgroundColor = "blue.50",
}: {
  backgroundColor?: string;
}) => (
  <Box
    w="6"
    h="6"
    backgroundColor={backgroundColor}
    borderRadius="sm"
    position="relative"
    display="flex"
    alignItems="center"
    justifyContent="center"
  >
    {/* Three human figures outline */}
    <Box position="relative" w="4" h="4">
      {/* Small figure 1 */}
      <Box
        position="absolute"
        top="1"
        left="0"
        w="1"
        h="2"
        backgroundColor="gray.600"
        borderRadius="full"
      />
      {/* Small figure 2 */}
      <Box
        position="absolute"
        top="1"
        left="1.5"
        w="1"
        h="2"
        backgroundColor="gray.600"
        borderRadius="full"
      />
      {/* Large figure */}
      <Box
        position="absolute"
        top="0.5"
        right="0"
        w="1.5"
        h="2.5"
        backgroundColor="gray.600"
        borderRadius="full"
      />
    </Box>
  </Box>
);
